import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import { WrapperProps } from './types';

type WrapperComponentProps = HTMLAttributes<HTMLDivElement> & WrapperProps & { children: ReactNode };

export const Wrapper = forwardRef<HTMLDivElement, WrapperComponentProps>(({ children, wrapperStyle, ...rest }, ref) => {
  if (!wrapperStyle) return <>{children}</>;

  return (
    <div ref={ref} {...rest} css={wrapperStyle} data-hide-calendar-tooltip='true'>
      {children}
    </div>
  );
});

Wrapper.displayName = 'Wrapper';
